/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
	name: 'serviceCategory',
	title: 'Service Category',
	type: 'document',
	fields: [
		{
			name: 'name',
			title: 'Category Name',
			type: 'string',
			validation: (Rule: any) => Rule.required(),
		},
		{
			name: 'subtitle',
			title: 'Category Subtitle',
			type: 'string',
		},
		{
			name: 'description',
			title: 'Description',
			type: 'text',
		},
		{
			name: 'image',
			title: 'Image',
			type: 'image',
			options: {
				hotspot: true,
			},
		},
		{
			name: 'order',
			title: 'Display Order',
			type: 'number',
			initialValue: 0,
			validation: (Rule: any) => Rule.min(0),
		},
		{
			name: 'isBusiness',
			title: 'Business Category',
			type: 'boolean',
			default: false,
		},
	],
	preview: {
		select: {
			title: 'name',
			subtitle: 'subtitle',
			media: 'image',
		},
	},
};
